import { createHeroView, createNavigationView } from './index'

const TermsAndConditions = () => import('../components/ContentPages/TermsAndConditions.vue')
const PrivacyPolicy = () => import('../components/ContentPages/PrivacyPolicy.vue')

export const routes = () => [
  {
    path: '/aszf',
    components: {
      default: TermsAndConditions,
      hero: createHeroView('content-page'),
      navigation: createNavigationView()
    },
    meta: {
      pageTitle: 'Terms & Conditions'
    }
  },
  {
    path: '/adatvedelmi-tajekoztato',
    components: {
      default: PrivacyPolicy,
      hero: createHeroView('content-page'),
      navigation: createNavigationView()
    },
    meta: {
      pageTitle: 'Privacy Policy'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/content-pages.js